
import React from 'react'
import { connect } from 'react-redux'
import Navigation from 'support/navigation'
import i18n from 'support/i18n'
import { showPopupDialog,
    showPopupErrorSnackbar,
    showPopupSuccessSnackbar,
} from 'support/popup_dialogs'
import ErrorSubmitModal from './ErrorSubmitContainer'
import View from './View'
import { postAdminCreateUser } from 'services/evaluation'


const mapStateToProps = state => {
    return {
      domainLoaded: state.data.domain.dataLoaded,
      postAdminCreateUserIsLoading:state.data.evaluation.postAdminCreateUserIsLoading
    }
}

const mapDispatchToProps = dispatch => {
    return {
        postAdminCreateUserFn: (paramsAdminCreateUser) => {
            const onSuccess = ({data}) => {
                console.log('after success', data)
                const message = 'Registration successfully!'
                showPopupSuccessSnackbar(message, dispatch)  
                // Navigation.navigateBack()
              }
              const onFailure = ({ data }) => {
                const messageTag =
                  // commented for not showing relevent error messages
                  // data && data.error && data.error.error
                  //   ? `BACKEND_ERRORS.${data.error.error}`
                  //   : 'BACKEND_ERRORS.UNEXPECTED'
                  data && data.error && data.error.error
                    ? `${data.error.desc}`
                    : 'BACKEND_ERRORS.UNEXPECTED'
                showPopupDialog(<ErrorSubmitModal description={i18n.t(messageTag)} />, dispatch)
                
              }

            dispatch(postAdminCreateUser(paramsAdminCreateUser,onSuccess,onFailure))
        },
    }
}


export default connect(
    mapStateToProps,
    mapDispatchToProps,
  )(View)